import { render, staticRenderFns } from "./LiveTab.vue?vue&type=template&id=dea9a698&scoped=true"
import script from "./LiveTab.vue?vue&type=script&lang=js"
export * from "./LiveTab.vue?vue&type=script&lang=js"
import style0 from "./LiveTab.vue?vue&type=style&index=0&id=dea9a698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea9a698",
  null
  
)

export default component.exports